import {h} from 'preact';
import Empty from './Empty';
import Content from './Content';
import Header from './Header';
import ItemCountBadge from './ItemCountBadge';
import Error from './Error';
import Loading from './Loading';

export const classList = {
    sectionBlock: 'flex select-none text-base border-b border-solid border-grey-lighter',
    cartEmpty: 'flex flex-1 max-w-full self-center align-center justify-center flex-col p-8 text-center text-lg'
};

export default {
    Loading,
    Error,
    ItemCountBadge,
    Empty,
    Content,
    Header
};
